import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const Shimmer = () => {
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: "shimmer" }, { children: "\u00A0" })) }));
};
export default Shimmer;
